export const ConfirmTransferToPublicService = Symbol('ConfirmTransferToPublicService');
